import React from "react";
import {
  Box,
  Table,
  Badge,
  Text,
  Spinner,
  Center,
  VStack,
} from "@chakra-ui/react";
import { ComplaintSearchItem } from "store/bbps/Complaint/bbpsComplaintTypes";

interface BbpsComplaintListProps {
  items: ComplaintSearchItem[];
  loading?: boolean;
  error?: string | null;
}

const BbpsComplaintList: React.FC<BbpsComplaintListProps> = ({ items, loading, error }) => {
  if (loading) {
    return (
      <Center py={10}>
        <VStack>
          <Spinner color="blue.500" />
          <Text fontSize="sm" color="gray.500">Searching...</Text>
        </VStack>
      </Center>
    );
  }

  if (error) {
    return (
      <Center py={10}>
        <Text color="red.500">{error}</Text>
      </Center>
    );
  }

  if (items.length === 0) {
    return null;
  }

  const getStatusColor = (status: string) => {
    switch (status.toUpperCase()) {
      case "INITIATED": return "blue";
      case "PENDING": return "yellow";
      case "SUCCESS": return "green";
      case "FAILED": return "red";
      case "REJECTED": return "red";
      case "RESOLVED": return "green";
      default: return "gray";
    }
  };

  return (
    <Box mt={6} overflowX="auto" borderWidth="1px" rounded="lg" bg="white">
      <Table.Root size="sm" variant="line">
        <Table.Header bg="gray.50">
          <Table.Row>
            <Table.ColumnHeader px={4} py={3}>Date</Table.ColumnHeader>
            <Table.ColumnHeader px={4} py={3}>Order ID / Txn Ref</Table.ColumnHeader>
            <Table.ColumnHeader px={4} py={3}>Mobile</Table.ColumnHeader>
            <Table.ColumnHeader px={4} py={3}>Status</Table.ColumnHeader>
            <Table.ColumnHeader px={4} py={3}>Reason</Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {items.map((item) => (
            <Table.Row key={item.id} _hover={{ bg: "gray.50" }}>
              <Table.Cell px={4} py={3}>
                <Text fontSize="xs" color="gray.600">
                  {new Date(item.createdAtUtc).toLocaleDateString()}
                </Text>
                <Text fontSize="10px" color="gray.400">
                  {new Date(item.createdAtUtc).toLocaleTimeString()}
                </Text>
              </Table.Cell>
              <Table.Cell px={4} py={3}>
                <VStack align="start" gap={0}>
                  <Text fontSize="xs" fontWeight="bold">ORD: {item.orderId}</Text>
                  <Text fontSize="10px" color="gray.500">REF: {item.txnReferenceId}</Text>
                </VStack>
              </Table.Cell>
              <Table.Cell px={4} py={3} fontSize="xs">{item.customerMobile}</Table.Cell>
              <Table.Cell px={4} py={3}>
                <Badge colorPalette={getStatusColor(item.ticketStatus || "INITIATED")} variant="solid" size="sm">
                  {item.ticketStatus}
                </Badge>
              </Table.Cell>
              <Table.Cell px={4} py={3}>
                <Text fontSize="xs" lineClamp={2}>
                  {item.responseReason || item.complaintDescription || "N/A"}
                </Text>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </Box>
  );
};

export default BbpsComplaintList;
